import { NgModule } from '@angular/core';
import { Routes, RouterModule, Router } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { CustomPreloading } from './core/custom-preloading/custom-preloading';
import { AuthenticationGuard } from './core/guards/authentication.guard';
import { PerformanceComponent } from './performance/performance.component';
import { BrowserInfoComponent } from './browser-info/browser-info.component';
import { HomePgsComponent } from './core/home-pgs/home-pgs.component';


const routes: Routes = [
	{
		path: '', canActivateChild: [ AuthenticationGuard ], children: [
			{ path: '', component: HomePgsComponent },
			{ path: 'mantenedor', loadChildren: () => import('app/manteiner/manteiner.module').then(m => m.ManteinerModule) },
			// { path: 'perfil', loadChildren: 'app/profile/profile.module#ProfileModule' },
			{ path: 'pagocontratistas', loadChildren: () => import('app/vendors-payment/vendors-payment.module').then(m => m.VendorsPaymentModule) },
			{ path: 'devoluciones', loadChildren: () => import('app/refund/refund.module').then(m => m.RefundModule) },
			{ path: 'reportes', loadChildren: () => import('app/reports/reports.module').then(m => m.ReportsModule) },
			{ path: 'fondogarantia', loadChildren: () => import('app/warranty-fund/warranty-fund.module').then(m => m.WarrantyFundModule) },
			{ path: 'proyectos', loadChildren: () => import('app/projects/projects.module').then(m => m.ProjectsModule) },
			{ path: 'info', component: BrowserInfoComponent, pathMatch: 'full' },
		]
	},
	{ path: 'performance', component: PerformanceComponent },
	{ path: 'null', redirectTo: '', pathMatch: 'full' }
];



@NgModule({
	imports: [RouterModule.forRoot(routes, {
    preloadingStrategy: CustomPreloading,
    relativeLinkResolution: 'legacy',
    initialNavigation: true ? 'enabledNonBlocking' : 'disabled'
  })],
	exports: [RouterModule]
})
export class AppRoutingModule { }
